import React from "react";
import EventsTab from "./EventsTab";

const defaultWidgetLayout = [
  { i: "./MonitoringWidget.jsx", x: 0, y: 0, w: 5, h: 10 },
  { i: "./CriticalEventWidget.jsx", x: 5, y: 0, w: 5, h: 10 },
  { i: "./LiveEventsWidget.jsx", x: 10, y: 0, w: 5, h: 10 },
];

function EventsLandingPage() {
  return (
    <div className="">
      {/* <WidgetContainer
          defaultLayout={defaultWidgetLayout}
          lsField="eventsPageWidgetLayout"
        /> */}
      <div className=" mt-2 position-relative">
        <EventsTab />
      </div>
    </div>
  );
}

export default EventsLandingPage;
